import React, {useEffect, useState} from 'react';
import {useOktaAuth} from '@okta/okta-react';
import {toRelativeUrl} from '@okta/okta-auth-js';
import {Outlet} from 'react-router-dom';
import {callLogEvent} from '../../Common/Util';

export const RequiredAuth = () => {
  const {oktaAuth, authState} = useOktaAuth();
  const [isLoggedIn, setLoggedIn] = useState(false);
  console.log('authState:', authState);
  useEffect(() => {
    if (!authState) {
      return;
    }

    if (!authState?.isAuthenticated) {
      sessionStorage.clear();
      oktaAuth.tokenManager.clear();
      const originalUri = toRelativeUrl(
        window.location.href,
        window.location.origin
      );
      oktaAuth.setOriginalUri(originalUri);
      oktaAuth.signInWithRedirect();
    }
  }, [oktaAuth, authState, authState?.isAuthenticated]);

  if (!authState || !authState?.isAuthenticated) {
    return <div style={{
    display: "flex", 
    justifyContent: "center", // Centers horizontally
    alignItems: "center",     // Centers vertically
    height: "100vh"           // Takes up the full height of the viewport
}}>
    Loading...
</div>;
  } else {
    sessionStorage.setItem('gpid', authState.idToken.claims.gpid);
    sessionStorage.setItem('name', authState.idToken.claims.FirstName);
    sessionStorage.setItem('emailid', authState.idToken.claims.email);
    sessionStorage.setItem('role', authState.idToken.claims.pepappdwdroles);
    sessionStorage.setItem('accessToken', authState.accessToken.accessToken);
    sessionStorage.setItem(
      'pepappdwdroles',
      authState?.idToken.claims.pepappdwdroles
    );
    
    // console.log('pepappdwdroles:', authState?.idToken.claims.pepappdwdroles);
    if (!isLoggedIn) {
      setLoggedIn(true);
      callLogEvent('USER_LOGGED_IN', 'User successfully authenticated to DWD');
    }
  }

  return <Outlet />;
};
